import { orderRefundStatusIntegral, refundmentTypeIntegral } from 'json/goods-order-options'
export let refundOrderLabels = [
  {
    label: '订单号',
    type: 'input',
    clearable: true,
    value: 'orderNumber', // 需返回数据的字段名
    options: []
  },
  {
    label: '申请退还积分时间',
    type: 'time-slot',
    startName: 'applyStartTime', // 返回数据时，开始时间的字段名
    endName: 'applyEndTime', // 返回数据时，结束时间的字段名
    value: 'createdtime'
  },
  {
    label: '退还积分方式',
    type: 'select',
    clearable: true,
    value: 'refundmentType',
    options: refundmentTypeIntegral
  },
  {
    label: '退还积分编号',
    type: 'input',
    clearable: true,
    value: 'refundOrderNumber'
  },
  {
    label: '退还积分状态',
    type: 'select',
    clearable: true,
    value: 'orderRefundStatus',
    options: orderRefundStatusIntegral
  }
]
export let refundTableLabel = [
  {
    label: '退还积分编号',
    value: 'refundmentDetails.refundOrderNumber'
  },
  {
    label: '订单编号',
    value: 'orderNumber'
  },
  {
    label: '商品名称',
    value: 'goodsName'
  },
  {
    label: '退还积分',
    value: 'refund_points'
  },
  {
    label: '退还积分方式',
    value: 'refundmentType'
  },
  {
    label: '退还积分申请时间',
    value: 'applyTime'
  },
  {
    label: '退还积分状态',
    value: 'orderRefundStatus'
  }
]
// 退还积分列表状态筛选
export let refundOrderStatusTab = [
  {
    label: '全部退还积分订单',
    value: 'all'
  },
  {
    label: '待退还积分',
    value: 'COMMIT'
  },
  {
    label: '退还积分完成',
    value: 'REFUND_COMPLETED'
  }
]
